export const PAYER_REPORT_TEXT = 'Payers Report';
export const PAYER_REPORT_VALUE = 'payer';

export const PAYER_REPORT_BY_USER_TEXT = 'Payers Report By User';
export const PAYER_REPORT_BY_USER_VALUE = 'payerbyuser';

export const PAYMENT_RECEIPTS_REPORT_TEXT = 'Payment Receipts Report';
export const PAYMENT_RECEIPTS_REPORT_VALUE = 'paymentreceiptsreport';

export const RECIPIENT_REPORT_TEXT = 'Recipient Report';
export const RECIPIENT_REPORT_VALUE = 'recipientreport';

export const TIN_REPORT_TEXT = 'TIN Match Report';
export const TIN_REPORT_VALUE = 'tinreport';

export const W9_REPORT_TEXT = 'W9 Report';
export const W9_REPORT_VALUE = 'w9report';

export const W8_REPORT_TEXT = 'W8 Report';
export const W8_REPORT_VALUE = 'w8report';

export const OPT_IN_REPORT_TEXT = 'Opt-In Request Report';
export const OPT_IN_REPORT_VALUE = 'optinrequestreport';

export const UNSUBMITTED_REPORT_TEXT = 'Unsubmitted Forms Report';
export const UNSUBMITTED_REPORT_VALUE = 'unsubmittedformsreport';

export const SUBMITTED_REPORT_TEXT = 'Submission History Report';
export const SUBMITTED_REPORT_VALUE = 'submissionhistoryreport';

export const STATE_SUBMITTED_REPORT_TEXT = 'State Submission History Report';
export const STATE_SUBMITTED_REPORT_VALUE = 'statesubmissionhistoryreport';

export const FORM_DELIVERY_REPORT_TEXT = 'Forms Delivery Report';
export const FORM_DELIVERY_REPORT_VALUE = 'formsdeliveryreport';

export const GENERATE_INVOICE_TEXT = 'Generate Invoice';
export const GENERATE_INVOICE_VALUE = 'generateinvoice';

export const QBO_VENDOR_TEXT = 'QuickBooks Online Vendor History Report';
export const QBO_VENDOR_VALUE = 'qbovendorreport';

export const EMAIL_REQUEST_TEXT = 'Email Request Status';
export const EMAIL_REQUEST_VALUE = 'emailrequeststatus';

export const ALL_SELECTED = 'All Selected';
export const SELECT_ALL = "Select All"
export const NONE_SELECTED = "None Selected";

export const SELECT_PAYERS = "Select Payers";
export const SELECT_USER = "Select User";
export const SELECT_TAX_YEAR = "Select Tax Year";
export const SELECT_FORMS = "Select Form";
export const STATE_PAYROLL_SUBMITTED_REPORT_TEXT = 'State Payroll Submission History Report';
export const STATE_PAYROLL_SUBMITTED_REPORT_VALUE = 'statepayrollsubmissionhistoryreport';

export const reportOptions = [
    { label: PAYER_REPORT_TEXT, value: PAYER_REPORT_VALUE },
    { label: PAYER_REPORT_BY_USER_TEXT, value: PAYER_REPORT_BY_USER_VALUE },
    { label: PAYMENT_RECEIPTS_REPORT_TEXT, value: PAYMENT_RECEIPTS_REPORT_VALUE },
    { label: RECIPIENT_REPORT_TEXT, value: RECIPIENT_REPORT_VALUE },
    { label: TIN_REPORT_TEXT, value: TIN_REPORT_VALUE },
    { label: W9_REPORT_TEXT, value: W9_REPORT_VALUE },
    { label: W8_REPORT_TEXT, value: W8_REPORT_VALUE },
    { label: OPT_IN_REPORT_TEXT, value: OPT_IN_REPORT_VALUE },
    { label: UNSUBMITTED_REPORT_TEXT, value: UNSUBMITTED_REPORT_VALUE },
    { label: SUBMITTED_REPORT_TEXT, value: SUBMITTED_REPORT_VALUE },
    { label: STATE_SUBMITTED_REPORT_TEXT, value: STATE_SUBMITTED_REPORT_VALUE },
    { label: FORM_DELIVERY_REPORT_TEXT, value: FORM_DELIVERY_REPORT_VALUE },
    { label: GENERATE_INVOICE_TEXT, value: GENERATE_INVOICE_VALUE },
    { label: QBO_VENDOR_TEXT, value: QBO_VENDOR_VALUE },
    { label: EMAIL_REQUEST_TEXT, value: EMAIL_REQUEST_VALUE },
    { label: STATE_PAYROLL_SUBMITTED_REPORT_TEXT, value: STATE_PAYROLL_SUBMITTED_REPORT_VALUE },
]

export const tabListWithTitleObj = [
    {
        title: {
            titleText: "1099 Vendor Copy eDelivery Status",
        },
    },
    {
        title: {
            titleText: "W-9 e-Solicitation Request Status",
        },
    },
    {
        title: {
            titleText: "Opt-In Request to Recipients Status",
        },
    },
];


export const REPORT_LOADING_STATES = {
    FILTER_LOADING: "FILTER_LOADING",
    FILTER_READY: "FILTER_READY",
    REPORT_RUN_LOADING: "REPORT_RUN_LOADING",
    REPORT_RUN_READY: "REPORT_RUN_READY",
    SECONDARY_ACTION_LOADING: "SECONDARY_ACTION_LOADING",
    SECONDARY_ACTION_READY: "SECONDARY_ACTION_READY",
    GRID_LOADING: "GRID_LOADING",
    GRID_READY: "GRID_READY",
    HEADERS_LOADING: "HEADERS_LOADING",
    HEADERS_READY: "HEADERS_READY",
    UPDATE_EMAIL_LOADING: "UPDATE_EMAIL_LOADING",
    UPDATE_EMAIL_READY: "UPDATE_EMAIL_READY",
}

export const REPORT_LOADING_STATES_MESSAGE_MAP = {
    [REPORT_LOADING_STATES.FILTER_LOADING]: "",
    [REPORT_LOADING_STATES.FILTER_READY]: "",
    [REPORT_LOADING_STATES.REPORT_RUN_LOADING]: "",
    [REPORT_LOADING_STATES.REPORT_RUN_READY]: "",
    [REPORT_LOADING_STATES.SECONDARY_ACTION_LOADING]: "",
    [REPORT_LOADING_STATES.SECONDARY_ACTION_READY]: "",
    [REPORT_LOADING_STATES.GRID_LOADING]: "",
    [REPORT_LOADING_STATES.GRID_READY]: "",
    [REPORT_LOADING_STATES.HEADERS_LOADING]: "",
    [REPORT_LOADING_STATES.HEADERS_READY]: "",
}